import React from 'react';
import { CardSubdued, Row, Column, Text } from '@innovaccer/design-system';

function NestedErrorRenderer({ data }) {
  if (!data.error) {
    return false;
  }
  return (
    <CardSubdued className="mb-4 mt-3 mr-4 ml-9">
      <Row className="my-3">
        <Column size={3}>
          <Text weight="strong">Error message</Text>
        </Column>
        <Column>
          <Text>{data.error}</Text>
        </Column>
      </Row>
    </CardSubdued>
  );
}

export default NestedErrorRenderer;
